module.exports = __webpack_public_path__ + "img/case4.f9b88f48.png";